import React from "react";

type Props = {
    company_name: string;
    your_name: string;
    company_name_error?: string;
    your_name_error?: string;
    setValue: (name: string, value: string) => void;
};

export const CompanyAndName = ({ company_name, your_name, company_name_error, your_name_error, setValue }: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">会社名 / お名前</div>
            <div className="form-flex-input form-flex-input-2col">
                <label>
                    <input type="text" name="company" placeholder="会社名" required
                        className={company_name_error ? 'form-input-error' : ''}
                        value={company_name}
                        onChange={(e) => setValue('company_name', e.target.value)}
                    />
                    {company_name_error && <span className="form-error-message">{company_name_error}</span>}
                </label>
                <label>
                    <input type="text" name="your_name" placeholder="お名前" required
                        className={your_name_error ? 'form-input-error' : ''}
                        value={your_name}
                        onChange={(e) => setValue('your_name', e.target.value)}
                    />
                    {your_name_error && <span className="form-error-message">{your_name_error}</span>}
                </label>
            </div>
        </div>
    );
};
